export const LOAD_CONTROLLER_PERMISSIONS_DATA_IN_PROGRESS = "LOAD_CONTROLLER_PERMISSIONS_DATA_IN_PROGRESS";
export const loadControllerPermissionsDataInProgress = () => ({
  type: LOAD_CONTROLLER_PERMISSIONS_DATA_IN_PROGRESS,
});

export const LOAD_APP_ROLES_DATA_SUCCESS = "LOAD_APP_ROLES_DATA_SUCCESS";
export const loadAppRolesDataSuccess = (data) => ({
  type: LOAD_APP_ROLES_DATA_SUCCESS,
  payload: { data },
});

export const LOAD_CONTROLLERS_LIST_DATA_SUCCESS = "LOAD_CONTROLLERS_LIST_DATA_SUCCESS";
export const loadControllersListDataSuccess = (data) => ({
  type: LOAD_CONTROLLERS_LIST_DATA_SUCCESS,
  payload: { data },
});

export const LOAD_ROLE_CONTROLLER_PERMISSIONS_DATA_SUCCESS = "LOAD_ROLE_CONTROLLER_PERMISSIONS_DATA_SUCCESS";
export const loadRoleControllerPermissionsDataSuccess = (data) => ({
  type: LOAD_ROLE_CONTROLLER_PERMISSIONS_DATA_SUCCESS,
  payload: { data },
});


export const LOAD_TENANT_ROLE_DATA_SUCCESS = "LOAD_TENANT_ROLE_DATA_SUCCESS";
export const loadTenantRoleDataSuccess = (data) => ({
  type: LOAD_TENANT_ROLE_DATA_SUCCESS,
  payload: { data },
});


export const LOAD_CONTROLLER_TENANT_PERMISSION_DATA_SUCCESS = "LOAD_CONTROLLER_TENANT_PERMISSION_DATA_SUCCESS";
export const loadControllerTenantPermissionDataSuccess = (data) => ({
  type: LOAD_CONTROLLER_TENANT_PERMISSION_DATA_SUCCESS,
  payload: { data },
});

export const LOAD_CONTROLLER_PERMISSIONS_DATA_FAILURE = "LOAD_CONTROLLER_PERMISSIONS_DATA_FAILURE";
export const loadControllerPermissionsDataFailure = () => ({
  type: LOAD_CONTROLLER_PERMISSIONS_DATA_FAILURE,
});

export const CONTROLLER_PERMISSIONS_OPERATION_COMPLETED = "CONTROLLER_PERMISSIONS_OPERATION_COMPLETED";
export const controllerPermissionsOperationCompleted = () => ({
  type: CONTROLLER_PERMISSIONS_OPERATION_COMPLETED,
});


